var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-me-contain"},[_c('Navbar',{attrs:{"title":"关于我们"}}),_c('div',{staticClass:"inner",domProps:{"innerHTML":_vm._s(_vm.aboutDom)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }